import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';
import '../styles/LoginRegister.css';
//esse é o certo
const Login = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({ username_or_email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const storeUserData = (data) => {
    console.log("Dados recebidos para armazenamento:", data); // Verificar os dados recebidos
    localStorage.setItem('token', data.token);
    localStorage.setItem('username', data.username);
    localStorage.setItem('email', data.email);
    localStorage.setItem('is_staff', data.is_staff);


    if (onLoginSuccess) {
      onLoginSuccess(data.is_staff);
    }

  
    navigate('/');
    window.location.reload(); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true); 

    try {
      const response = await axios.post('https://crmesquita.com.br/api/login/', formData);
      storeUserData(response.data); 
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setLoading(false); 
    }
  };

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    setLoading(true); 

    try {
      const response = await axios.post('https://crmesquita.com.br/api/google-login/', {
        token: credentialResponse.credential,
      });
      storeUserData(response.data); 
    } catch (error) {
      console.error('Erro ao fazer login com Google:', error);
    } finally {
      setLoading(false); 
    }
  };

  const handleErrorResponse = (error) => {
    if (error.response && error.response.data && error.response.data.error) {
      const errorMessage = error.response.data.error;

      if (errorMessage.includes('e-mail invalidos')) {
        setErrors({ username_or_email: 'Nome de usuário ou e-mail invalidos.' });
      } else if (errorMessage.includes('Senha incorreta')) {
        setErrors({ password: 'Senha incorreta.' });
      } else if (errorMessage.includes('inativa')) {
        setErrors({ username_or_email: 'Sua conta está inativa. Verifique seu e-mail para ativá-la.' });
      }
    } else {
      setErrors({ general: 'Erro ao fazer login. Tente novamente.' });
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-title">Login</h1>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username_or_email">Usuário ou E-mail:</label>
            <input
              type="text"
              id="username_or_email"
              name="username_or_email"
              value={formData.username_or_email}
              onChange={handleInputChange}
              required
              className="form-input"
            />
            {errors.username_or_email && (
              <p className="error-message">{errors.username_or_email}</p>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              className="form-input"
            />
            {errors.password && (
              <p className="error-message">{errors.password}</p>
            )}
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Carregando...' : 'Entrar'}
          </button>
          {errors.general && (
            <p className="error-message">{errors.general}</p>
          )}
        </form>

        <div className="login-divider">Ou entre com:</div>
        <div className="google-login-container">
          <GoogleLogin
            onSuccess={handleGoogleLoginSuccess}
            onError={() => console.error('Erro ao fazer login com Google')}
          />
        </div>
        
        <div className="forgot-password-container">
          <Link to="/forgot-password" className="forgot-password-link">
            Esqueceu a senha?
          </Link>
        </div>

        <div className="register-link">
          {'Não tem uma conta?'}{' '}
          <Link to="/register" className="register-link-text">
            Registre-se
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
